import { render, staticRenderFns } from "./IconLeaderboard.vue?vue&type=template&id=2cae0de8"
import script from "./IconLeaderboard.vue?vue&type=script&lang=js"
export * from "./IconLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports